export default __webpack_public_path__ + "static/logo_white-2f2c40b9ffc61ff8699ef8221f1aeb71.svg";